import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/envago/Button/Button';

interface DonePanelProps {
    // The results were queued (offline) instead of accepted by the server: the panel must not
    // claim a transmission yet — same wording as the manual flow's pending success screen.
    pending: boolean;
    hasOtherOpenJobs: boolean;
    onClose: () => void;
    onNextMeter: () => void;
}

// Bottom sheet like the other assistant panels, but visually borrowing the shared
// Dialog's language: 40% scrim (dialog--overlay), text-2xl text-primary title
// (dialog--title), font-light body and side-by-side flex-1 actions (dialog--actions).
const DonePanel = ({ pending, hasOtherOpenJobs, onClose, onNextMeter }: DonePanelProps) => {
    const { t } = useTranslation();

    return (
        <div className={'absolute inset-0 bg-black bg-opacity-40'}>
            <div className={'absolute bottom-0 left-0 right-0 bg-white rounded-t-xl p-4'}>
                <h2 className={'text-2xl text-primary mt-1 mb-2'}>{t(pending ? 'jobs.details.pendingSuccessTitle' : 'aiReading.done.title')}</h2>
                <p className={'text-sm font-light'}>{t(pending ? 'jobs.details.pendingSuccessHint' : 'aiReading.instructions.done')}</p>
                <p data-testid="done-progress" className={'text-sm mt-1 ' + (hasOtherOpenJobs ? 'font-light' : 'font-medium')}>
                    {t(hasOtherOpenJobs ? 'aiReading.done.moreOpen' : 'aiReading.done.allDone')}
                </p>
                <div className={'flex gap-2 mt-6'}>
                    {hasOtherOpenJobs ? (
                        <>
                            <Button secondary={true} className={'flex-1'} onClick={onClose}>
                                {t('aiReading.buttons.close')}
                            </Button>
                            <Button primary={true} className={'flex-1'} onClick={onNextMeter}>
                                {t('aiReading.buttons.nextMeter')}
                            </Button>
                        </>
                    ) : (
                        <Button primary={true} className={'flex-1'} onClick={onClose}>
                            {t('aiReading.buttons.close')}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DonePanel;
